import { render, staticRenderFns } from "./AddressErrorModal.vue?vue&type=template&id=cf228a4c&scoped=true"
import script from "./AddressErrorModal.vue?vue&type=script&lang=js"
export * from "./AddressErrorModal.vue?vue&type=script&lang=js"
import style0 from "./AddressErrorModal.vue?vue&type=style&index=0&id=cf228a4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf228a4c",
  null
  
)

export default component.exports